import { TablePaginationConfig } from "antd";
import { driverRatingsApi, passengerRatingsApi } from "api/rating";
import { useNotificationContext } from "contexts/NotificationContext";
import { defaultTableData, ITableData } from "models";
import { IRating } from "models/rating";
import { useEffect, useState } from "react";

export default function useRating() {
  const [activeTab, setActiveTab] = useState<"drivers" | "passengers">(
    "drivers"
  );
  const { showError } = useNotificationContext();
  const [driverRates, setDriverRates] =
    useState<ITableData<IRating>>(defaultTableData);
  const [passengerRates, setPassengerRates] =
    useState<ITableData<IRating>>(defaultTableData);

  useEffect(() => {
    fetchDriverRates();
  }, [driverRates.page, driverRates.search]); // eslint-disable-line

  useEffect(() => {
    fetchPassengerRates();
  }, [passengerRates.page, passengerRates.search]); // eslint-disable-line

  const fetchDriverRates = async () => {
    setDriverRates((prev) => ({ ...prev, loading: true }));

    const { data: response, error } = await driverRatingsApi(
      driverRates.page,
      driverRates.per_page,
      driverRates.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setDriverRates((prev) => ({ ...prev, ...response, loading: false }));
    } else {
      showError(error!.message);
      setDriverRates((prev) => ({ ...prev, loading: false }));
    }
  };

  const fetchPassengerRates = async () => {
    setPassengerRates((prev) => ({ ...prev, loading: true }));

    const { data: response, error } = await passengerRatingsApi(
      passengerRates.page,
      passengerRates.per_page,
      passengerRates.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setPassengerRates((prev) => ({ ...prev, ...response, loading: false }));
    } else {
      showError(error!.message);
      setPassengerRates((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleTabClick = (tab: "drivers" | "passengers") => setActiveTab(tab);
  const handleDriverRateSearch = (e: React.ChangeEvent<HTMLInputElement>) =>
    setDriverRates((prev) => ({ ...prev, search: e.target.value }));
  const handlePassengerRateSearch = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPassengerRates((prev) => ({ ...prev, search: e.target.value }));

  const handleDriverRatePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setDriverRates((prev) => ({ ...prev, page: current }));
  };
  const handlePassengerRatePageChange = ({
    current,
  }: TablePaginationConfig) => {
    if (current) setPassengerRates((prev) => ({ ...prev, page: current }));
  };

  return {
    driverRates,
    passengerRates,
    activeTab,
    handleDriverRateSearch,
    handlePassengerRateSearch,
    handleTabClick,
    handleDriverRatePageChange,
    handlePassengerRatePageChange,
  };
}
